import React from 'react';
import styled from 'styled-components';
import { black } from '@avangard/ui/colors';

type EditableRowProps = {
    children: React.ReactNode;
    title?: string;
    className?: string;
};

const Root = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 16px 12px;
`;

const Title = styled.div`
    width: 100%;
    margin-bottom: 10px;
    color: ${black[60]};
    font-size: 1.4rem;
`;

const Content = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;

const EditableRow = (props: EditableRowProps): React.ReactElement => {
    const { title, children, ...otherProps } = props;

    return (
        <Root {...otherProps}>
            {title ? <Title>{title}</Title> : null}
            <Content>{children}</Content>
        </Root>
    );
};

export { EditableRow };
